"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SearchFilter_1 = require("../../components/SearchFilter");
SearchFilter_1.SearchFilter.each('.search-page');
